import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { ControlsModule } from 'segov-sigepo-lib';
import { SegovPage } from 'src/app/app.routes';
import { LinkClickable, SegovSigepoHeaderSectionComponent } from 'src/app/controls/segov-sigepo-header-section/segov-sigepo-header-section.component';
import { SegovSigepoPortalBodyComponent } from 'src/app/controls/segov-sigepo-portal-body/segov-sigepo-portal-body.component';
import { GlossarioOutputDto } from 'src/app/domain/DTOs/output/glossario.output.dto';
import { obterGlossario, obterGlossarioFinish } from 'src/app/stateManagement/actions/glossario.action';
import { ObterGlossarioState } from 'src/app/stateManagement/reducers/obter-glossario.reducer';
import { selectDadosObterGlossario } from 'src/app/stateManagement/selectors/obter-glossario.selector';
import { ComponentMessages } from 'src/app/utils/component.messages';

@Component({
  selector: 'app-glossario-page',
  standalone: true,
  imports: [
      SegovSigepoPortalBodyComponent,
      SegovSigepoHeaderSectionComponent,
      ControlsModule
    ],
  templateUrl: './glossario-page.component.html',
  styleUrl: './glossario-page.component.css'
})
export class GlossarioPageComponent implements OnInit, OnDestroy{
  public title = ComponentMessages.centralDeRelacionamento;
  public errorMsg = '';
  public exibeConteudoAccordions = false;

  public GlossariosOutputDto: GlossarioOutputDto[] = [];
  private subGlossario: Subscription;

  public RouteStack: LinkClickable[] = [
      { title: "Início", route: SegovPage.Inicio },
      { title: "Atendimento", route: SegovPage.Glossario },
      { title: "Glossário", route: SegovPage.Glossario }
    ]

  constructor(
      private readonly storeObterGlossario: Store<{ obterGlossarioState: ObterGlossarioState }>) {
        this.subGlossario = new Subscription();
    }

  ngOnInit(): void {
    this.subGlossario = this.storeObterGlossario.select(selectDadosObterGlossario)
        .subscribe(result => {
          this.GlossariosOutputDto = result?.dados??[];
        });

     this.getObterGlossario();
  }

  ngOnDestroy(): void {
    this.storeObterGlossario.dispatch(obterGlossarioFinish());
    this.subGlossario.unsubscribe();
  }

  public toggleAccordions() {
    this.exibeConteudoAccordions = !this.exibeConteudoAccordions;
  }

  private getObterGlossario() {
    this.storeObterGlossario.dispatch(obterGlossario());
  }
}
